import React, { FC } from 'react';
import { toast } from 'react-toastify';
import { FormattedMessage, useIntl } from 'react-intl';

import { LegislationInfos } from '../../../../legislation.types';
import { doctrineAnalytics } from '../../../../../../utils/analyticsUtils';
import { copy } from '../../../../../../utils/clipboard';
import { useRestrictedModal } from '../../../../../../components/modal/useRestrictedModal';
import { useUser } from '../../../../../../user/useUser';
import { formatArticleToCopy } from './copyLegislationButtonUtils';
import { MaterialIcon } from '../../../../../../components/material-icon/MaterialIcon';

import styles from './copy_legislation_button.module.scss';

type Props = {
  legislationInfos: LegislationInfos;
};

export const CopyLegislationButton: FC<Props> = ({ legislationInfos }) => {
  const source = 'clipboard_copy_dropdown';
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();
  const intl = useIntl();
  const { articleId, rawContent, title } = legislationInfos;

  const sendAnalytics = () => {
    doctrineAnalytics('Legislation ButtonCopyClicked', {
      articleId,
      reportOriginalQueryKey: true,
    });
  };

  const copyAndConfirm = () => {
    if (!accessPremium) return openRestrictedModal({ source });
    const legislationClipboard = intl.formatMessage(
      {
        id: 'action/CopyLegislationButton.tsx/2',
      },
      {
        title,
        url: window.location.href,
      },
    );
    const text = formatArticleToCopy({ legislationClipboard, rawContent });
    copy(text);
    toast(
      <p>
        <FormattedMessage id="action/CopyLegislationButton.tsx/1" />
      </p>,
    );
    sendAnalytics();
  };

  return (
    <div className={styles.container}>
      <MaterialIcon name="file_copy" className={styles.icon} />
      <span
        className={styles.link}
        role="button"
        tabIndex={0}
        onClick={copyAndConfirm}
      >
        <FormattedMessage id="action/CopyLegislationButton.tsx/3" />
      </span>
    </div>
  );
};
